import { InputBaseReactComponent } from './../input-base-react/input-base-react.component';
import { Component, forwardRef, Input, OnChanges, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';

@Component({
  selector: 'app-input-string-react',
  templateUrl: './input-string-react.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputStringReactComponent),
      multi: true
    }
  ]
})

export class InputStringReactComponent extends InputBaseReactComponent implements ControlValueAccessor, OnInit, OnChanges {

  //#region .  Variaveis  .

  spanMaxSize?: string = undefined;
  spanMinSize?: string = undefined;
  spanAlphaNumeric?: string = undefined;
  spanEmail?: string = undefined;

  //#endregion

  //#region .  Inputs  .

  @Input() maxSize?: number = undefined;
  @Input() minSize?: number = undefined;
  @Input() onlyAlphaNumeric = false;
  @Input() validateEmail = false;

  //#endregion

  //#region .  LifeCycle Methods e Construtor
  constructor() {
    super();
  }

  // chama método ngOnInit da classe base e prepara valores de spans de validação
  ngOnInit(): void {

    super.ngOnInit();

    if (this.maxSize) {
      if (!this.spanMaxSize) {
        this.spanMaxSize = `Tamanho máximo de ${this.maxSize.toString()} caractéres`;
      }
    }

    if (this.minSize) {
      if (!this.spanMinSize) {
        this.spanMinSize = `Tamanho mínimo de ${this.minSize.toString()} caractéres`;
      }
    }

    if (this.onlyAlphaNumeric) {
      if (!this.spanAlphaNumeric) {
        this.spanAlphaNumeric = 'O valor deve ser alfa-numérico';
      }
    }

    if (this.validateEmail) {
      if (!this.spanEmail) {
        this.spanEmail = 'E-mail inválido';
      }
    }

    this.loadValidators();
    this.setAndUpdateValidators();
  }

  // chama método ngOnChanges da classe base e efetua o recarregamento de validadores.
  ngOnChanges(): void {
    super.ngOnChanges();
    this.loadValidators();
    this.setAndUpdateValidators();
  }

  protected validEmail(control: FormControl): any {
    if (!control.value) {
      return undefined;
    }

    return Validators.email(control);
  }

  //#endregion

  //#region .  Métodos  .

  // método para carregamento de validadores
  private loadValidators(): void {
    if (this.maxSize) {
      this.insertValidator(Validators.maxLength(this.maxSize));
    }

    if (this.minSize) {
      this.insertValidator(Validators.minLength(this.minSize));
    }

    if (this.onlyAlphaNumeric) {
      this.insertValidator(Validators.pattern('^[A-Za-zÀ-ú0-9\-._ \']+'));
    }

    if (this.validateEmail) {
      this.insertValidator(this.validEmail.bind(this));
    }

  }

  // função retorna se quantidade de caracteres do campo foi excedida
  public validMaxSize(): boolean {
    return this.control?.errors?.maxlength;
  }

  public validMinSize(): boolean {
    return this.control?.errors?.minlength;
  }

  // função retorna se existe erro de preenchimento no campo
  public validAlphaNumeric(): boolean {
    return this.control?.errors?.pattern;
  }

  // função retorna se existe erro de preenchimento no campo de email
  public validMail(): boolean {
    if (this.validEmail) {
      return this.control?.errors?.email;
    } else {
      return false;
    }
  }

  //#endregion

}
